<script>
import VConsole from "vconsole";
import { mapState } from "vuex";
import GlobalNotify from "@/components/global-notify";
import CloseDialog from "@/components/close-dialog";

import { RingBottomNavigation } from "bottom-navigation-vue";
import "bottom-navigation-vue/dist/style.css";
import { CONSTANTS } from "@/helpers/constants";
import Loading from "@/components/loading.vue";

new VConsole({ theme: "light" });

export default {
  name: "MetfoneLayout",
  components: {
    CloseDialog,
    GlobalNotify,
    RingBottomNavigation,
    Loading,
    // AppHeader
  },
  data() {
    return {
      notifyMessage: null,
      notifyShow: false,
      loadingShow: false,
      platform: -1,
      closeShow: false,
      callbackClose: null,
      selected: 1,
      options: [],
      isTabActive: "",
    };
  },
  computed: {
    ...mapState("userStore", ["profile", "defaultParam"]),
    ...mapState("notifyStore", ["dataMessage"]),
    ...mapState("loadingStore", ["status"]),
    ...mapState("headerStore", ["title"]),
    ...mapState("routerStore", ["isClose"]),
    ...mapState("routerStore", ["isShowActiveTabs"]),
    ...mapState("routerStore", ["isShowContentBuyMetfoneEsim"]),
    ...mapState("routerStore", ["isShowContentMobileServices"]),
    ...mapState("routerStore", ["isShowContentTV360"]),
  },

  async created() { 
    if (process.env.VUE_APP_ENV != "dev") {
      await this.initProfile();
      this.changeTitle(this.$t(this.title));
    } else {
      let data = {
        id: "app-ac0cce36-05a2-488b-b308-630a2113d333",
        middleName: "",
        osVersion: "26.0",
        appVersion: "1.0.1",
        email: "long.nguyenminh2704@gmail.com",
        secret_key:
          "B9DF5CBCA2A2249406B2DB871E0FB04BABAEF09027310527992891A1AF5864AD",
        lastName: "Metfone",
        nationality: "KHM",
        fullName: "Minh Long Metfone",
        lang: "en_US", //en_US || kh_KH
        appLang: "en", //en || kh
        dobShort: "16-12",
        sex: "M",
        appId: "app-ac0cce36-05a2-488b-b308-630a2113d333",
        phone: "+855315445204",
        firstName: "Minh Long", 
      };
      console.log("FAKE getProfile data:", data);
      await this.$store.dispatch("userStore/setProfile", data);
      // await this.$store.dispatch("userStore/isMetfoneNumber", "855315445204");
      await this.$store.dispatch("userStore/isMetfoneNumber", data.phone);
      await this.$store.dispatch("userStore/setDefaultParam");
      await this.$store.dispatch("userStore/setChangeProfile");
      let findLang = CONSTANTS.Locales.find((x) => x.code == data.appLang.toLowerCase());
      this.$i18n.locale = findLang ? findLang.forward : "en";
    }

    const listOption = [
      { id: 1, icon: "wap-home", title: this.$t("home") },
      { id: 2, icon: "clock", title: this.$t("history") },
    ];
    this.options = [];
    this.options.push(...listOption);

    await this.$store.dispatch("userStore/setDefaultParam");
    this.checkPlatform();
  },
  watch: {
    $route: {
      handler: function (value, oldVal) {
        //console.log("Route watch ", this.selected, value, oldVal);
        if (value.fullPath.includes("/home?tab=tabTV360")) {
          this.isTabActive = "tabTV360";
          console.log("[TV360] watch /home?tab=tabTV360");
          if (oldVal && oldVal.fullPath.includes("/tv360-payment-success")) {
            this.selected = 1;
            console.log("[tv360his] After payment success, go to tv360 home");
          } else if (
            oldVal &&
            oldVal.fullPath.includes("/tv360-payment-faild")
          ) {
            this.selected = 1;
            console.log("[tv360his] After payment faild, go to tv360 home");
          } else if (
            oldVal &&
            oldVal.fullPath.includes("/tv360-request-received")
          ) {
            console.log("[tv360his] After request received, go to tv360 home");
            setTimeout(() => {
              this.selected = 1;
              setTimeout(() => {
                this.selected = 2;
              }, 100);
            }, 0);
          } else {
            console.log("[tv360his] Go to tv360 history");
          }
        } else {
          //console.log("Route changed to other -->", value.name);
          if (value.name == "History") {
            this.$store.dispatch("headerStore/setTitle", "history");
            this.selected = 2;
          } else {
            this.$store.dispatch("headerStore/setTitle", "metfone_services");
            if (value.name == "Home" && !value.query?.tab) {
              this.selected =
                this.isShowContentMobileServices === "history" ? 2 : 1;
              this.$store.dispatch(
                "routerStore/setIsShowContentBuyMetfoneEsim",
                "buyEsim",
              );
            } else if (
              value.name == "Home" &&
              value.query?.tab == "buyMetfoneEsim" &&
              this.isShowContentBuyMetfoneEsim == "buyEsim"
            ) {
              this.selected = 1;
            } else if (
              value.name == "Home" &&
              value.query?.tab == "buyMetfoneEsim" &&
              this.isShowContentBuyMetfoneEsim == "history"
            ) {
              this.selected = 2;
            } else {
              this.selected = 0;
            }
          }
        }
      },
      immediate: true,
    },
    "$route.query": {
      handler: function (query) {
        if (query.tab) {
          console.log("Query tab changed:", query.tab);
          this.activeName = query.tab;
        }
      },
      immediate: true,
    },
    dataMessage: {
      handler: function (value) {
        this.notifyShow = true;
        this.notifyMessage = value;
      },
    },
    status: {
      handler: function (value) {
        this.loadingShow = value;
      },
    },
    isClose: {
      handler: function (value) {
        if (value) {
          this.closeShow = true;
        }
      },
    },
    title: {
      handler: function (value) {
        if (value) {
          this.changeTitle(this.$t(value));
        }
      },
    },
    isShowActiveTabs: {
      handler: function (value) {
        //console.log("isShowActiveTabs changed to --> layout:", value);
        this.isTabActive = value;
        if (value == "mobileServices") {
          this.selected = this.isShowContentMobileServices === "history" ? 2 : 1;
        }
        // handle eSIM tab
        if (
          value == "buyMetfoneEsim" &&
          this.isShowContentBuyMetfoneEsim == "buyEsim"
        ) {
          this.selected = 1;
        }

        if (
          value == "buyMetfoneEsim" &&
          this.isShowContentBuyMetfoneEsim == "history"
        ) {
          this.selected = 2;
        }

        // handle TV360 tab explicitly to avoid dual-active state
        if (value == "tabTV360") {
          console.log(
            "[Hoaiß] Go to tv360history subtab = ",
            this.isShowContentTV360,
          );
          if (this.isShowContentTV360 == "history") {
            this.selected = 2;
            this.$store.dispatch(
              "routerStore/setIsShowContentTV360",
              "history",
            );
          } else {
            this.selected = 1;
            this.$store.dispatch("routerStore/setIsShowContentTV360", "home");
          }

          //this.$store.dispatch("routerStore/setIsShowContentTV360", "history");
        }
      },
      immediate: true,
    },
    selected: {
      handler: function (value) {
        if (value) {
          //console.log("selected changed to --> layout:", value);
          if (this.$route.name === "Home") {
            const queryTab = this.$route.query?.tab;
            if (!queryTab || queryTab === "") {
              // Mobile package tab selected
              if (value == 1) {
                this.$store.dispatch(
                  "routerStore/setIsShowContentMobileServices",
                  "home",
                );
                if (this.$route.path !== "/home") {
                  this.$router.replace("/home");
                }
                return;
              }
              if (value == 2) {
                this.$store.dispatch(
                  "routerStore/setIsShowContentMobileServices",
                  "history",
                );
                if (this.$route.path !== "/home") {
                  this.$router.replace("/home");
                }
                return;
              }
            }
            if (queryTab === "buyMetfoneEsim") {
              if (value == 1) {
                this.$store.dispatch(
                  "routerStore/setIsShowContentBuyMetfoneEsim",
                  "buyEsim",
                );
                return;
              }
              if (value == 2) {
                this.$store.dispatch(
                  "routerStore/setIsShowContentBuyMetfoneEsim",
                  "history",
                );
                return;
              }
            }
            if (queryTab === "tabTV360") {
              if (value == 1) {
                this.$store.dispatch("routerStore/setIsShowContentTV360", "home");
                return;
              }
              if (value == 2) {
                this.$store.dispatch(
                  "routerStore/setIsShowContentTV360",
                  "history",
                );
                return;
              }
            }
          }

          //tv360
          if (this.isTabActive == "tabTV360") {
            if (value == 1) {
              console.log("[tv360his] Go to tv360 home 1");
              this.$store.dispatch("routerStore/setIsShowContentTV360", "home");
            }
            //
            else if (value == 2) {
              console.log("[tv360his] Go to tv360 history 2");
              this.$store.dispatch(
                "routerStore/setIsShowContentTV360",
                "history",
              );
            }
          }
          //esim
          else if (this.isTabActive == "buyMetfoneEsim") {
            if (value == 1) {
              this.$store.dispatch(
                "routerStore/setIsShowContentBuyMetfoneEsim",
                "buyEsim",
              );
            }
            if (value == 2) {
              this.$store.dispatch(
                "routerStore/setIsShowContentBuyMetfoneEsim",
                "history",
              );
            }
          }
          // mobile package
          else if (this.isTabActive == "mobileServices") {
            if (value == 1) {
              this.$store.dispatch(
                "routerStore/setIsShowContentMobileServices",
                "home",
              );
              if (this.$route.path !== "/home") {
                this.$router.replace("/home");
              }
            }
            if (value == 2) {
              this.$store.dispatch(
                "routerStore/setIsShowContentMobileServices",
                "history",
              );
              if (this.$route.path !== "/home") {
                this.$router.replace("/home");
              }
            }
          }
          //mobile service default route handling
          else {
            if (value == 1) {
              this.$router.replace("/home");
            }
            if (value == 2) {
              console.log("Go to history");
              this.$router.push("/history");
            }
          }
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.$bridge.registerHandler("closeApp", (data, callback) => {
      this.closeShow = true;
      this.callbackClose = callback
      /*
      // On eSIM entry pages, "back" should return to eSIM tab instead of closing app.
      if (
        this.$route.path === "/buy-new-metfone-esim" ||
        this.$route.path === "/change-to-esim-metfone"
      ) {
        callback({ status: false });
        this.$router.replace({ path: "/home", query: { tab: "buyMetfoneEsim" } });
        return;
      }

      callback({ status: false });
      this.closeShow = true;
      // this.callbackClose = callback
      // callback({ status: true | false });
      */
    });

    this.$bridge.registerHandler("redirectPage", (data, callback) => {
      callback({ status: false });
    });

    this.changeTitle(this.$t(this.title));
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  },
  methods: {
    color_primary() {
      return CONSTANTS.color_primary;
    },
    handleVisibilityChange() {
      if (document.visibilityState === "visible") {
        this.changeTitle(this.$t(this.title));
      }
    },
    changeTitle(title) {
      const contentData = {
        title: title,
        color: "#ffffff",
        bgColor: this.color_primary(),
      };
      this.$bridge.callHandler("setBarTitle", contentData).then((data) => {});
    },
    checkPlatform() {
      const isAndroidWebView =
        navigator.userAgent.toLowerCase().indexOf("android") > -1;

      // Check if the user agent contains "iPhone" or "iPad" to determine if it's an iOS WebView
      const isiOSWebView = /(iPhone|iPod|iPad)/i.test(navigator.userAgent);

      if (isAndroidWebView) {
        this.platform = 1;
      } else if (isiOSWebView) {
        this.platform = 2;
      } else {
        this.platform = 0;
      }
    },

    onBottomNavChange(value) {
      console.log("onBottomNavChange:", value);
    },

    async initProfile() {
      console.log("InitProfile called");
      try {
        await this.$bridge.callHandler("getProfile").then(async (data) => {     
          console.log("InitProfile result:", data); 
          if (data) { 
            const dataProfile = {
              id: data.id,
              appId: data.appId,
              lang:  data.lang === "KH" ? "kh_KH" : "en_US",
              appLang: data.lang === "KH" ? "kh" : "en",

              firstName: data.firstName,
              lastName: data.lastName,
              middleName: data.middleName,
              fullName: data.fullName,
              sex: data.sex,
              age: data.age,
              dobShort: data.dobShort || data.dobFull,
              dobFull: data.dobFull,
               
              phone: data.phone,
              email: data.email,
 
              country: data.country,
              nationality: data.nationality,
  
              city: data.city,
              
              address: data.address,
              occupation: data.occupation,
              addrCode: data.addrCode,
              
              nidNumber: data.nidNumber,
              nidType: data.nidType, // ID_NATIONAL or PASSPORT
              nidExpirationDate: data.nidExpirationDate,
               
              appVersion: data.appVersion, 
              osVersion: data.osVersion, 
              secret_key: data.secret_key, 
            };
            
            await this.$store.dispatch("userStore/setProfile", dataProfile); 
            await this.$store.dispatch("userStore/isMetfoneNumber", dataProfile.phone);
            await this.$store.dispatch("userStore/setDefaultParam");
            await this.$store.dispatch("userStore/setChangeProfile");

            let findLang = CONSTANTS.Locales.find(
              (x) => x.code == dataProfile.appLang.toLowerCase(),
            );
            this.$i18n.locale = findLang ? findLang.forward : "en";
          }
        }); 
      } catch (error) {
        console.error("InitProfile error:", error);
      }     
    },
  },
};
</script>

<template>
  <div>
    <CloseDialog v-model:is-show.sync="closeShow" />
    <!-- <AppHeader v-if="platform != 2" /> -->
    <div>
      <router-view />
      <!-- SubTan (home/history) -->
      <RingBottomNavigation
        v-if="selected != 0"
        class="bottom-navigation"
        :options="options"
        v-model="selected"
        @change="onBottomNavChange"
        :borderColor="color_primary()"
        :titleColor="color_primary()"
        :icon-color="color_primary()"
      >
        <template #icon="{ props }">
          <van-icon
            style="margin-top: 20px"
            size="16"
            :name="props.icon"
          ></van-icon>
        </template>
        <template #title="{ props }">
          <b class="icon-navigation">{{ props.title }}</b>
        </template>
      </RingBottomNavigation>
    </div>
    <GlobalNotify
      v-model:is-show.sync="notifyShow"
      :data-message="notifyMessage"
    />
    <loading :show-loading="loadingShow" />
  </div>
</template>
<style>
.icon-navigation {
  font-size: 12px !important;
}

.rg-btn-title {
  letter-spacing: normal !important;
}

.rg-btn-title {
  text-transform: capitalize !important;
}

.rg-btn-container-foreground {
  z-index: 99 !important;
  background: #fff !important;
}
</style>
